export enum ProductTypes {
  physical = 1,
  subscription = 2,
  onDemand = 3,
  experience = 4,
  donation = 5,
  eGift = 6,
  brandedProduct = 7,
}
